import fetch from "auth/FetchInvoice";
import fetchMeInvoice from "auth/FetchMeInvoice";
import axiosInstance from "auth/FetchInterceptor";
import {
  GET_ALL_TEMPLATE_INVOICE,
  GET_STORE_INVOICE,
  LOGIN_INVOICE,
  UPSET_STORE_INVOICE,
  SIGNATURE_USB_HASH_INVOICE,
  CREATE_USB_HASH_INVOICE,
  UPSET_ORDER_INVOICE,
  GET_ORDER_INVOICE,
  GENERATE_INVOICE,
  SIGN_ORDER_INVOICE,
  GET_CUSTOMER_INVOICE,
  CREATE_PDF_INVOICE,
  GET_INVOICE_UUID,
  CREATE_HSM_INVOICE,
  CREATE_DRAFT_INVOICE,
  SENT_INVOICE_TAX,
  CHANGE_STATE_SENT_INVOICE,
  UPDATE_DRAFT_INVOICE,
  UPDATE_DRAFT_EXPORT,
  CHANGE_INVOICE_PARTNER,
  GET_TEMPLATE_ME_INVOICE,
  LOGIN_ME_INVOICE,
  GENERATE_ME_INVOICE,
  CREATE_ME_INVOICE,
  SIGN_ME_INVOICE,
  GET_STATUS_INVOICE_PUBLIC,
  CHANGE_STATE_ME_INVOICE,
  DOWNLOAD_ME_INVOICE,
  SEARCH_ORDER_INVOICE,
  DELETE_ORDER_INVOICE,
} from "../constants/ApiConstant";
import axios from "axios";

const InvoiceService = {};

// VInvoice
InvoiceService.loginSInvoice = (data) => {
  return fetch.post(LOGIN_INVOICE, data);
};

InvoiceService.getAllInvoiceTemplates = (taxCode) => {
  return fetch.post(GET_ALL_TEMPLATE_INVOICE, {
    taxCode: taxCode,
    invoiceType: "all",
  });
};

InvoiceService.createUSBHash = (data) => {
  return fetch.post(`${CREATE_USB_HASH_INVOICE}/${data?.sellerInfo?.sellerTaxCode}`, data);
};

InvoiceService.signatureUSBInvoice = (data) => {
  return fetch.post(SIGNATURE_USB_HASH_INVOICE, data);
};

InvoiceService.createHSMInvoice = (data) => {
  return fetch.post(`${CREATE_HSM_INVOICE}/${data?.sellerInfo?.sellerTaxCode}`, data);
};

InvoiceService.updateDraftExport = (data) => {
  return axiosInstance.post(UPDATE_DRAFT_EXPORT, data);
};

InvoiceService.getStoreInvoice = (storeId) => {
  return axiosInstance.get(`${GET_STORE_INVOICE}/${storeId}`);
};

InvoiceService.upsetStoreInvoice = (data) => {
  return axiosInstance.post(UPSET_STORE_INVOICE, data);
};

InvoiceService.getOrderInvoice = (orderId) => {
  return axiosInstance.get(`${GET_ORDER_INVOICE}/${orderId}`);
};

InvoiceService.upsetOrderInvoice = (data) => {
  return axiosInstance.post(UPSET_ORDER_INVOICE, data);
};

InvoiceService.generateInvoice = (data) => {
  return axiosInstance.post(GENERATE_INVOICE, data);
};

InvoiceService.signInvoice = (data) => {
  return axiosInstance.post(SIGN_ORDER_INVOICE, data);
};

InvoiceService.getCustomerInvoice = (userId) => {
  return axiosInstance.get(`${GET_CUSTOMER_INVOICE}/${userId}`);
};

InvoiceService.createPdfInvoice = (data) => {
  return fetch.post(CREATE_PDF_INVOICE, data, {
    headers: {
      "Content-type": "application/json",
    },
  });
};

InvoiceService.createDraftInvoice = (data) => {
  return fetch.post(`${CREATE_DRAFT_INVOICE}/${data?.sellerInfo?.sellerTaxCode}`, data, {
    headers: {
      "Content-type": "application/json",
    },
  });
};

InvoiceService.updateDraftInvoice = (data) => {
  return axiosInstance.post(UPDATE_DRAFT_INVOICE, data);
};

InvoiceService.getInvoiceUuid = (data) => {
  var formBody = [];
  for (var property in data) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  return fetch.post(GET_INVOICE_UUID, formBody, {
    headers: {
      "Content-type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
};

InvoiceService.sentInvoiceTax = (data) => {
  let formBody = [];
  for (var property in data) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  return fetch.post(SENT_INVOICE_TAX, formBody, {
    headers: {
      "Content-type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
};

InvoiceService.changeStateSendInvoice = (data) => {
  return axiosInstance.post(CHANGE_STATE_SENT_INVOICE, data);
}

InvoiceService.searchBusiness = (taxCode) => {
  return axiosInstance.get(`/v2/business/${taxCode}`, {baseURL: process.env.REACT_APP_VIETQR});
}

InvoiceService.getCountryList = () => {
  return axios.get("https://restcountries.com/v3.1/all");
};

InvoiceService.getCertificateInfo = (data) => {
  return fetch.get(
    `/management-signature/search?page=0&size=10&tenantBranchId.equals=&taxCode.contains=${data.taxCode}&signatureType.equals=${data.authTypeInvoice}`,
    {baseURL: 'https://vinvoice.viettel.vn/api/cluster4/services/einvoiceapplication/api'}
  );
};

// MeInvoice
InvoiceService.loginMeInvoice = (data) => {
  return fetchMeInvoice.post(LOGIN_ME_INVOICE, data);
};

InvoiceService.getAllMeInvoiceTemplates = () => {
  return fetchMeInvoice.get(`${GET_TEMPLATE_ME_INVOICE}?invoiceWithCode=true&ticket=false`);
};

InvoiceService.createMeInvoice = (data) => {
  return fetchMeInvoice.post(CREATE_ME_INVOICE, data);
};

InvoiceService.getStatusMeInvoice = (data) => {
  return fetchMeInvoice.post(`${GET_STATUS_INVOICE_PUBLIC}?invoiceWithCode=true&invoiceCalcu=false&inputType=1`, data);
};

InvoiceService.downloadMeInvoice = (data) => {
  return fetchMeInvoice.post(`${DOWNLOAD_ME_INVOICE}?invoiceWithCode=true&invoiceCalcu=false&downloadDataType=pdf`, data);
};

InvoiceService.signMeInvoice = (data) => {
  return axiosInstance.put(SIGN_ME_INVOICE, data);
};

InvoiceService.changeInvoicePartner = (data) => {
  return axiosInstance.put(CHANGE_INVOICE_PARTNER, data);
}

InvoiceService.generateMeInvoice = (data) => {
  return axiosInstance.post(GENERATE_ME_INVOICE, data);
};

InvoiceService.changeStatusMeInvoice = (data) => {
  return axiosInstance.put(CHANGE_STATE_ME_INVOICE, data);
};

InvoiceService.getMeInvoiceTemplates = (data) => {
  return axiosInstance.post(GET_TEMPLATE_ME_INVOICE, data);
};

InvoiceService.getPdfMeInvoice = (data) => {
  return axiosInstance.post(DOWNLOAD_ME_INVOICE, data);
};

InvoiceService.upSetStatusMeInvoice = (data) => {
  return axiosInstance.post(GET_STATUS_INVOICE_PUBLIC, data);
};

InvoiceService.createMeInvoiceData = (data) => {
  return axiosInstance.post(CREATE_ME_INVOICE, data);
};


InvoiceService.searchOrderInvoice = (data) => {
  return axiosInstance.post(SEARCH_ORDER_INVOICE, data);
};

InvoiceService.deleteOrderInvoice = (data) => {
  return axiosInstance.put(DELETE_ORDER_INVOICE, data);
};

export default InvoiceService;